import React, { useState } from 'react'
import { connectTransfers as endpoints } from '../api_urls'
import { client } from '../utils'
import PropTypes from 'prop-types'

const NextButton = props => {
  let [nextButtonBusy, toggleNextButtonBusy] = useState(false)

  const handleNextClick = () => {
    toggleNextButtonBusy(true)
    client
      .post(endpoints.getRecentTransfersStartingAfter(), {
        starting_after: props.startingAfter,
        account_id: props.accountID,
      })
      .then(resp => {
        props.updateHasMoreTransfers(resp.data.has_more)
        props.updateTransfers(resp.data.data)
        if (resp.data.has_more) {
          props.updateStartingAfter(resp.data.starting_after)
        }
        props.updateEndingBefore(resp.data.ending_before)
        toggleNextButtonBusy(false)
      })
      .catch(err => {
        console.error(err)
      })
  }

  return (
    <button
      className="btn btn-myed btn-default btn-default-myed btn-sm-myed ml-2"
      onClick={() => handleNextClick()}
    >
      {nextButtonBusy ? (
        <span className="fal fa-spinner fa-spin mr-2 text-muted" />
      ) : null}
      Next
    </button>
  )
}

NextButton.propTypes = {
  startingAfter: PropTypes.string,
  accountID: PropTypes.string,
}

export default NextButton
